<template>

  <el-form label-position="left" label-width="auto" size="small">
    <el-collapse :accordion="true">
      <chart-title :element="element"></chart-title>
      <chart-sub-title :element="element"></chart-sub-title>
      <chart-legend :element="element"></chart-legend>
      <chart-grid :element="element"></chart-grid>
      <el-collapse-item title="绘制" name="绘制">

        <el-form-item label="主题">
          <el-button-group>
            <el-button @click="changeType('normal')" size="small">普通</el-button>
            <el-button @click="changeType('doughnut')" size="small">环形图</el-button>
            <el-button @click="changeType('rose')" size="small">玫瑰图</el-button>
          </el-button-group>
        </el-form-item>

        <el-form-item label="文本颜色">
          <el-color-picker v-model="ele.option.series[0].label.color" show-alpha
                           :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']">
          </el-color-picker>
        </el-form-item>

      </el-collapse-item>
    </el-collapse>
  </el-form>

</template>

<script>
import ChartTitle from "@/components/design-report/chart/chartStyle/chartTitle.vue";
import ChartLegend from "@/components/design-report/chart/chartStyle/chartLegend.vue";
import ChartSubTitle from "@/components/design-report/chart/chartStyle/chartSubTitle.vue";
import ChartGrid from "@/components/design-report/chart/chartStyle/chartGrid.vue";
import chartFactory from "@/components/design-report/chartFactory";

export default {
  components: {  ChartGrid, ChartSubTitle, ChartLegend, ChartTitle},
  props: {
    element: {
      type: Object,
      default: () => {
      }
    },
    report: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      ele: null
    }
  },
  created() {
    this.ele = this.element;
  },
  methods: {
    changeType(type){
      this.ele.option.type = type;
      chartFactory.changePieType(this.element)
    }
  }


}

</script>

<style scoped lang="scss">

</style>